// extracted by mini-css-extract-plugin
export default {"sessionThumbnails":"_1aFv9EyNKZSBH1UXXJsclv","canvas":"lg_jwAuUWrt_Jpcph2-5H","title":"_1zeXI-jSh8gao_q49skWnI","canvasButton":"_1QQC5d16Qph-wFfmsKJ8uh"};